import {Injectable} from "@angular/core";
import {AbstractControl, ValidationErrors, ValidatorFn, Validators} from "@angular/forms"
import {StringUtilsHelper} from "./strings.helper";

@Injectable({
  providedIn: 'root'
})
export class ValidationHelper {

  /**
   * Funcion para escribir solo numeros y en el caso de requerir decimal, se habilita con una opcion, tambien cuenta con la opcion de validar longitud.
   * @param $event Evento recibido del input donde se implementa la funcion para su validacion.
   * @param value Es el valor del input al que se esta validando, por ejemplo 1234.25 | 2.5 | 5 | 0.2587, etc.
   * @param length Parametro opcional para indicar la longitud del numero, solo para enteros.
   * @param isDecimal Parámetro que indica si el numero a recibir permite deciamales, con la opcion de recibir longitud de los decimales.
   * @param lengthDecimal Longitud despues del punto, por default son 2 digitos.
   * @returns Retorna un valor true o false, si es true permite escribir el digito o punto decimal, si es false el control input no escribe el valor presionado
   */
    static validateNumbersAndDecimals($event, value: string, length?: number, isDecimal?: boolean, lengthDecimal?: number){
      if(!StringUtilsHelper.notNullOrUndefinedOrEmpty(lengthDecimal))
        lengthDecimal = 2;
      // Extract ascii code
      let code = ($event.which) ? $event.which : $event.keyCode;
  
      let isNumber = false;
      if(code === 8) { // backspace.
        return true;
      } else if(isDecimal && code === 46){  //point
        isNumber = true;
      } else if(code >= 48 && code <= 57) { // only numbers.
        isNumber = true;
      } else{ // other keys.
        return false;
      }
      //
      if (StringUtilsHelper.notNullOrUndefinedOrEmpty(length)) {
        let valDecimal = false;
        let valueStr: string = value.concat($event.key);
        if(isDecimal && valueStr.includes(".")){
          const onlyWholeNumbers: number = length - (lengthDecimal + 1);
          let arrayVal: string[] = valueStr.split(".");
          if (arrayVal.length === 1) {
            valDecimal = arrayVal[0].length <= onlyWholeNumbers;
          } else if (arrayVal.length === 2) {
            valDecimal = (arrayVal[0].length <= onlyWholeNumbers) && (arrayVal[1].length <= lengthDecimal);
          } else {
            valDecimal = false;
          }
          return isNumber && valDecimal;
        } else {
          return isNumber && valueStr.length <= length;
        }
      }
      return isNumber;
    }

    static default(disable: boolean){
        return [{value:'', disabled: disable }];
    }
    static validateBasic(disable: boolean){
        return [{value:'', disabled: disable }, Validators.required];
    }
    static validateBasicComponent(value: string, disable: boolean, required?: boolean){
        if (required) {
            return [{value:value, disabled: disable }, Validators.required];
        } else {
            return [{value:value, disabled: disable }];
        }
    }
    static validateCurp(disable: boolean){
        return [{value:'', disabled: disable },
            Validators.compose([
                Validators.required,
                Validators.minLength(18),
                Validators.maxLength(18),
                curpValidator()
            ])
        ];
    }
    static validatePhoneOrMobile(disable: boolean){
        return [{value:'', disabled: disable },
            Validators.compose([
                Validators.pattern(/^([0-9]{10})$/),
                Validators.minLength(10),
                Validators.maxLength(10)])
        ];
    }
    static validateNames(disable: boolean){
        return [{value:'', disabled: disable },
            Validators.compose([
                Validators.required,
                Validators.pattern(/^((\d{2})?[a-zA-Z áéíóúÁÉÍÓÚñÑ_]+(\d{2})?)*$/),
                Validators.minLength(1),
                Validators.maxLength(50)
            ])
        ];
    }
    static validateNamesCustom(disable: boolean){
        return [{value:'', disabled: disable },
            Validators.compose([
                Validators.required,
                Validators.maxLength(50),
                namesValidator()
            ])
        ];
    }
    static validateNameProfile(disable: boolean){
        return [{value:'', disabled: disable },
            Validators.compose([
                Validators.required,
                Validators.pattern(/^((\d{2})?[a-zA-Z áéíóúÁÉÍÓÚñÑ_]+(\d{2})?)*$/),
                Validators.maxLength(50)])
        ];
    }
    static validatePassword(disable: boolean){
        return [{value:'', disabled: disable },
            Validators.compose([
                Validators.required,
                Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!%&@#$^*?_~])[A-Za-z\d!%&@#$^*?_~]{8,}$/),
                Validators.minLength(8)])
        ];
    }
    static validateMinOrMax(min: number, max: number, disable: boolean, noRequired?: boolean){
        let elementsVal: ValidatorFn[] = [];
        if (!noRequired) {
            elementsVal.push(Validators.required);
        }
        if(min > 0){
            elementsVal.push(Validators.minLength(min))
        }
        if (max > 0) {
            elementsVal.push(Validators.maxLength(max))
        }
        return [{value:'', disabled: disable }, Validators.compose(elementsVal)];
    }
    static validateZipCode(disable: boolean){
        let elementsVal = [
            Validators.required,
            Validators.minLength(5),
            Validators.maxLength(5),
            Validators.pattern(/^([0-9]{5})$/),
        ];
        return [{value:'', disabled: disable }, Validators.compose(elementsVal)];
    }
    static validateEmail(disable: boolean){
        return [{value:'', disabled: disable },
            Validators.email
        ];
    }
    static validateExtension(disable: boolean){
        return [{value:'', disabled: disable },
            Validators.pattern(/^([0-9]{0,10})$/)
        ];
    }
    static validateNumbers(disable: boolean){
      return [{value:'', disabled: disable },
        Validators.pattern(/^([0-9]*)$/)
    ];
  }
    static checkPassword(text: string){
        let expUpper = /[A-Z]/;
        let expLower = /[a-z]/;
        let expNumber = /[0-9]/;
        let expSpecial = /[!%&@#$^*?_~]/;
        let lsOk: any[] = [];
        lsOk.push(text.length >= 8);
        lsOk.push(!!expUpper.exec(text) );
        lsOk.push(!!expLower.exec(text) );
        lsOk.push(!!expNumber.exec(text) );
        lsOk.push(!!expSpecial.exec(text) );
        return lsOk;
    }
    static defaultCheckbox(disable: boolean,value: boolean){
        return [{value: value, disabled: disable }];
    }
    static validatorBasic(){
        return Validators.required;
    }
    static checkAccent(text){
        let expAccent = /[áéíóúÁÉÍÓÚ]/;
        return expAccent.test(text);
    }
    static checkCharacter(text){
        let expCharacter = /[^\s\-\/,.'´a-zA-ZñÑüÜ]/gm;// /[^\s\-\/,.'´]/gm;
        let test = expCharacter.test(text);
        return test;
    }
    static checkLetter(text){
        let expCharacter = /([a-zA-ZñÑüÜ])$/i;
        let test = expCharacter.test(text);
        return test;
    }
    static checkLetterX(text){
        let expCharacterX = /^([x|X]{2})$/gm;
        let test = expCharacterX.test(text);
        return test;
    }
    static onlyLetterX(text){
        let expCharacterX = /^([x|X]*)$/gm;
        let test = expCharacterX.test(text);
        return test;
    }
    static checkCharacterEnd(text){
        let hasDoubleCharacter: boolean[] = [];
        const characters = [" ", "-", "/", ",", ".", "'", "´"];
        let expCharacter = /^[\s\-\/,.'´]/gm;
        let expCharacterMultiple = /^(?!.*?([\s\-\/,.'´])\1).+/gm;
        if(expCharacter.test(text)){
          const valText: string = text;
          if(valText.startsWith("'") || valText.startsWith("´"))
            return false;
          else
            return true;
        } else if(!expCharacterMultiple.test(text))
            return true;
        else {
            const length = text.length - 1;
            if(length > -1){
                for (let index = length; index > length - 2; index--) {
                    let char = text.charAt(index);
                    let existChar = characters.find(x => x === char);
                    hasDoubleCharacter.push(StringUtilsHelper.notNullOrUndefinedOrEmpty(existChar));
                }            
            }
            return ((hasDoubleCharacter[0] && !hasDoubleCharacter[1]) || (hasDoubleCharacter[0] && hasDoubleCharacter[1]));
        }
    }
    static validateAlphanumeric(defaultValue: string, disable: boolean, isRequired:boolean, minLength: number, maxLength: number){
        let pattern = /^[a-zA-Z0-9áéíóúÁÉÍÓÚñÑ ]*$/
        let validators = [
            Validators.pattern(pattern),
            Validators.minLength(minLength),
            Validators.maxLength(maxLength)
        ];

    if (isRequired) {
      validators.push(Validators.required);
    }

    return [{value: defaultValue, disabled: disable},
      Validators.compose(validators)
    ];
  }

  static validateOnlyText(defaultValue: string, disable: boolean, isRequired: boolean, minLength?: number, maxLength?: number) {
    let validators = this.validateTextFn(isRequired, minLength, maxLength, false, true);

    return [{value: defaultValue, disabled: disable}, validators];
  }

  static validateTextAndNumbers(defaultValue: string, disable: boolean, isRequired: boolean, minLength?: number, maxLength?: number) {
    let validators = this.validateTextFn(isRequired, minLength, maxLength, true, false);

    return [{value: defaultValue, disabled: disable}, validators];
  }

  static validateTextFn(isRequired: boolean, minLength?: number, maxLength?: number, numbers?: boolean, accents?: boolean){
    let pattern = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ ]*$/
    if(numbers && accents)
      pattern = /^[a-zA-Z0-9áéíóúÁÉÍÓÚñÑ ]*$/
    if(accents)
      pattern = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ ]*$/
    if(numbers)
      pattern = /^[a-zA-Z0-9ñÑ ]*$/

    let validators = [
      Validators.pattern(pattern)
    ];

    if (minLength) {
      validators.push(Validators.minLength(minLength));
    }

    if (maxLength) {
      validators.push(Validators.maxLength(maxLength));
    }

    if (isRequired) {
      validators.push(Validators.required);
    }

    return Validators.compose(validators);
  }

  static validateNamesNOM024(value: string, disable: boolean, required: boolean, minLength?: number, maxLength?: number) {
    let validators = [
      namesValidatorNOM24()
    ];

    if (maxLength) {
      validators.push(Validators.maxLength(maxLength));
    }

    if (required) {
      if (minLength) {
        validators.push(Validators.minLength(minLength));
      }
      validators.push(Validators.required);
    }

    return [{value: value, disabled: disable},
      Validators.compose(validators)
    ];
  }

  static validateDate(value: string, disable: boolean, required?: boolean) {
    let pattern = /^(0?[1-9]|[12][0-9]|3[01])\/(0?[1-9]|1[012])\/\d{4}$/
    if (required) {
      return [{value: value, disabled: disable}, Validators.required, Validators.pattern(pattern), valueDateValidator()];
    } else {
      return [{value: value, disabled: disable}, Validators.pattern(pattern), valueDateValidator()];
    }
  }

  static validateMobile(disable: boolean, required?: boolean){
      let validators = [Validators.pattern(/^([0-9]{10})$/),
        Validators.minLength(10),
        Validators.maxLength(10)];

      if (required){
        validators.push(Validators.required)
      }

    return [{value:'', disabled: disable },
      Validators.compose(validators)
    ];
  }

  static validateOtherTown(disable: boolean, required?: boolean){
    let validators = this.validateTextInAddressFn(required);

    return [ { value:'', disabled: disable }, validators ];
  }
  
  static validateTextInAddressFn(required?: boolean){
    let validators: ValidatorFn[] = [];
    validators.push(Validators.pattern(/^[0-9a-zA-ZñÑ .;\-_/()]*$/));

    if (required){
      validators.push(Validators.required)
    }
    return Validators.compose(validators);
  }

  static validateOtherTownFn(){
    return Validators.pattern(/^[0-9a-zA-ZñÑ .;\-_/()]*$/);
  }

}

export function confirmPasswordValidator(controlMatch: AbstractControl): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {

    if (StringUtilsHelper.notNullOrUndefinedOrEmpty(controlMatch.value)) {
      if (control.value !== controlMatch.value) {
        return {isNotEqualPwd: true};
      } else {
        return null;
      }
    }
    return null;
  }

}

export function changePasswordValidator(controlMatch: AbstractControl): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {

    if (StringUtilsHelper.notNullOrUndefinedOrEmpty(control.value)) {
      if (control.value !== controlMatch.value) {
        controlMatch.markAsTouched();
        controlMatch.setErrors({isNotEqualPwd: true});
      } else {
        controlMatch.markAsUntouched();
        controlMatch.setErrors(null);
      }
    }
    return null;
  }

}

export function passwordsNotEqualValidator(controlMatch: AbstractControl): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {

    if (StringUtilsHelper.notNullOrUndefinedOrEmpty(control.value) && StringUtilsHelper.notNullOrUndefinedOrEmpty(controlMatch.value)) {
      if (control.value === controlMatch.value) {
        control.setErrors({equalPwd: true});
        controlMatch.setErrors({equalPwd: true});
        return {equalPwd: true};
      } else {
        control.setErrors(null);
        controlMatch.setErrors(null);
        return null;
      }
    }
    return null;
  }
}

export function namesValidator(): ValidatorFn {
    return (control:AbstractControl) : ValidationErrors | null => {
        let value : string = control.value;
        if(StringUtilsHelper.notNullOrUndefinedOrEmpty(value) && value.length < 2){
            return { pattern: true, required: true };
        }
        if (StringUtilsHelper.notNullOrUndefinedOrEmpty(value) && value.length < 51) {
            if (ValidationHelper.checkCharacter(control.value)) {
                if (ValidationHelper.checkCharacterEnd(control.value)) {
                    return { pattern: true,  characterEnd: true };
                }
                else
                    return { pattern: true, otherCharacter: true };
            }
            if(ValidationHelper.checkAccent(control.value)){
                return { pattern: true, accent: true };
            }
            if (ValidationHelper.checkCharacterEnd(control.value)) {
                return { pattern: true,  characterEnd: true };
            }
            if(ValidationHelper.checkLetter(control.value)){
                if(!ValidationHelper.checkLetterX(control.value) && StringUtilsHelper.notNullOrUndefinedOrEmpty(control.value) && ValidationHelper.onlyLetterX(control.value)){
                    return { pattern: true, required: true };
                }
                return null;
            }
            if (ValidationHelper.checkCharacter(control.value)) {
                return { pattern: true, otherCharacter: true };
            }

        } else if(StringUtilsHelper.notNullOrUndefinedOrEmpty(value) && value.length > 50) {
            return control.getError("maxlength");
        }
        return null;
    }
}

export function curpValidator(): ValidatorFn {
    return (control:AbstractControl) : ValidationErrors | null => {
        let curp: string = control.value;
        const regx = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HMX](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3})|(^(X{4})(\d{6})(X{6})(\d{2}))$/gm;

        if (!StringUtilsHelper.notNullOrUndefinedOrEmpty(curp)) {
            return null;
        }
        curp = StringUtilsHelper.toUpper(curp);
        if (curp.length < 18) {
          control.markAsTouched();
          return control.getError("minlength");
        }
        if (curp.length > 18) {
          return control.getError("maxlength");
      }

        let obj = regx.exec(curp);
        if (!StringUtilsHelper.notNullOrUndefinedOrEmpty(obj)){
            return { pattern: true, format: true };
        }
        const yearCurp: number = StringUtilsHelper.getYearCurp(curp);
        const lastDigits: string = curp.substring(16, 18);
        const expNumbers = /^(?:\d{2})$/g;//Validation the last two digits (numbers)
        if(yearCurp < 2000){
            if(StringUtilsHelper.notNullOrUndefinedOrEmpty(lastDigits) && !expNumbers.test(lastDigits)){
                return { pattern: true, onlyNumbers: true };
            }
        } else {
            let exprLetter = /^([A-J])$/g;// validate that the penultimate one is a letter
            let exprLastNumber = /^(?:\d)$/g;// validate that the last one is a number
            if(StringUtilsHelper.notNullOrUndefinedOrEmpty(lastDigits) && !exprLetter.test(lastDigits.substring(0, 1))){
                return { pattern: true, onlyLetters: true };
            }
            if(StringUtilsHelper.notNullOrUndefinedOrEmpty(lastDigits) && !exprLastNumber.test(lastDigits.substring(1))){
                return { pattern: true, lastNumber: true };
            }
        }
        return null;
    }
}

export function valueDateValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let values: string[] = control.value.split("/");
    if (values.length < 3) {
      return {value: true}
    }

    return null;
  }
}

export function namesValidatorNOM24(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let value: string = control.value;
    if (StringUtilsHelper.notNullOrUndefinedOrEmpty(value) && value.length < 51) {

      if (ValidationHelper.checkAccent(control.value)) {
        return {pattern: true, accent: true};
      }
      if (ValidationHelper.checkCharacterEnd(control.value)) {
        return {pattern: true, characterEnd: true};
      }
      if (ValidationHelper.checkLetter(control.value)) {
        if (!ValidationHelper.checkLetterX(control.value) && StringUtilsHelper.notNullOrUndefinedOrEmpty(control.value) && ValidationHelper.onlyLetterX(control.value)) {
          return {pattern: true};
        }
        return null;
      }
      if (ValidationHelper.checkCharacter(control.value)) {
        return {pattern: true, otherCharacter: true};
      }

    } else if (StringUtilsHelper.notNullOrUndefinedOrEmpty(value) && value.length > 50) {
      return control.getError("maxlength");
    }
    return null;
  }
}

export function autocompleteValidation(listOptions: any[], max: number, isRequired: boolean): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if(isRequired && !control.value) {
      return { required: true };
    }
    if (control.value && control.value.length > max) {
      return { maxLength: true };
    }
    const index = listOptions.findIndex(option => {
      return new RegExp("^" + option.name + "$").test(control.value);
    });
    return index < 0 ? { noSelected: true } : null;
  };
}
